export const createStyle = (theme, componentConfig, BUILD_TIME_PARAMS) => {
  const createdStyles = {
    theme,
    componentConfig,
    BUILD_TIME_PARAMS
  };
  return createdStyles;
};
//# sourceMappingURL=createStyle.js.map